const state = {
  levelAData: []
}

const actions = {
  async getLevelAData({ state }) {
    if (state.levelAData.length == 0) {
      const result = await $http.get('td-regulation/cause/list', { size: 9999, current: 1, parentId: '11111', type: 2 })
      if (result.code == 200) {
        state.levelAData = result.data.records
      }
    }
    return state.levelAData
  }
}

const mutations = {
  setLevelAData(state, data) {
    state.levelAData = data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
